export const markAsDuplicate = async (studyId: string) => {
  const data = {
    duplicate: {
      review_study_id: studyId,
    },
  };

  const response = await fetch('/api/v1/duplicates', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (response.ok) {
    return Promise.resolve(studyId);
  }

  const defaultError =
    "Oh no! We're experiencing some technical difficulties right now, please try again later";
  try {
    const jsonData = await response.json();
    const error = jsonData?.data?.error;

    return Promise.reject(error || defaultError);
  } catch {
    return Promise.reject(defaultError);
  }
};
